var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam ERP Sipariş Sayısı',"data":_vm.reportCompanyData.totalErpOrder.toString(),"description":'Tüm Zamanlar',"loading":_vm.reportCompanyDataLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }